import { Droplet } from "lucide-react";
import { Reveal } from "../Reveal";
import { BRANDS } from "../../lib/data";

export default function Brands() {
  const row = [...BRANDS, ...BRANDS];
  return (
    <section id="brands" data-testid="brands-section" className="relative border-y border-ink-soft bg-ink py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <Reveal>
          <p className="text-center text-xs font-bold uppercase tracking-[0.3em] text-gold">Premium Oils We Trust</p>
          <p className="mx-auto mt-4 max-w-md text-center text-sm text-white/45">
            We use manufacturer-approved, top-tier oils — so your engine gets exactly what it deserves.
          </p>
        </Reveal>
      </div>

      <div className="relative mt-12 flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,#000_12%,#000_88%,transparent)]">
        <div className="marquee-track items-center gap-12 pr-12 md:gap-20 md:pr-20">
          {row.map((brand, i) => (
            <div key={i} data-testid="brand-item" className="group flex shrink-0 items-center gap-3">
              <Droplet className="h-4 w-4 fill-white/25 text-white/25 transition-colors group-hover:fill-gold group-hover:text-gold" strokeWidth={0} />
              <span className="font-display text-2xl font-medium uppercase tracking-tight text-white/45 transition-colors duration-300 group-hover:text-white md:text-3xl">
                {brand}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
